module.exports = __webpack_public_path__ + "static/media/arrow_left.97b4deaf.svg";